/**
 * Feedback API Service
 */
import { apiClient } from '../client';
import { API_ENDPOINTS } from '../../utils/constants';

export type FeedbackCategory = 'bug' | 'feature_request' | 'other';

export interface FeedbackCreateRequest {
  message: string;
  category: FeedbackCategory;
}

export const feedbackService = {
  submit: async (data: FeedbackCreateRequest): Promise<void> => {
    await apiClient.post(API_ENDPOINTS.FEEDBACK, data);
  },
};
